// extracted by mini-css-extract-plugin
module.exports = {"innerHeroWrapper":"page-hero_innerHeroWrapper__IhXoN","leftSide":"page-hero_leftSide__nlWW4","rightSide":"page-hero_rightSide__45_dm"};